const registry = {};
export function addDependency(name, onChange) {
  if (!registry[name]) {
    Object.defineProperty(registry, name, {
      value: onChange,
      writable: false,
    });
  }
}
export function getDependency(name) {
  return registry[name];
}
